export default "__VITE_ASSET__De_$a2L4__"